
import { Injectable, Inject } from '@angular/core'
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http'
import { Observable } from 'rxjs'
import { tap, take, map } from 'rxjs/operators';
import * as _ from 'lodash';

import { User } from '../models/user.model';
import { AuthService } from './auth.api';
import { DefaultHttpHeaderOptions } from './httpDefaultHeaderOptions.service';
interface ApiResponse {
  status: string,
  data?: object | string,
  body?: any
}

@Injectable({
  providedIn: 'root'
})

export class Request {
  protected environment: any
  private _baseUrl: string

  constructor(
    @Inject('AppEnvironment') environmentConfig,
    private http: HttpClient,
    private _authService: AuthService,
    private defaultHeaderOptions: DefaultHttpHeaderOptions
  ) {
    this.environment = environmentConfig;
    this._baseUrl = defaultHeaderOptions.baseUrl;

  }

  get baseUrl() {
    return this._baseUrl;
  }

  baseRequestOptions(): object {
    return this.defaultHeaderOptions.baseRequestOptions();
  }

  validateRefreshToken(val: any) {

    if (val.refresh_token !== undefined) {
      this._authService.refreshToken(val.refresh_token, this.environment.role);
    }
  }

  getApi_documents(url: string): Observable<any> {
    let header = this.defaultHeaderOptions.baseRequestOptions();
    header['responseType'] = 'blob' as 'json';
    delete header['observe'];

    return this.http.get<Blob>(this.baseUrl.concat(url), header);
  }

  // Base http APIs
  getApi(url: string): Observable<ApiResponse> {
    return this.http.get<ApiResponse>(this.baseUrl.concat(url), this.baseRequestOptions()).pipe(tap(res => {
      this.validateRefreshToken(res.body);
    }));
  }

  getApi1(url: string): Observable<ApiResponse> {
    return this.http.get<any>(url, this.baseRequestOptions()).pipe(tap(res => {
      this.validateRefreshToken(res.body);
    }));
  }

  getApiWithFullResponse(url: string): Observable<ApiResponse> {
    return this.http.get<any>(this.baseUrl.concat(url), this.baseRequestOptions()).pipe(tap(res => {
      localStorage.setItem('authenticated_token', res.headers.get('authorization'));
    }));
  }

  postApi(url: string, data?: object): Observable<ApiResponse> {
    return this.http.post<ApiResponse>(this.baseUrl.concat(url), data, this.baseRequestOptions()).pipe(tap(res => {
      this.validateRefreshToken(res.body);
    }));
  }

  patchApi(url: string, data?: object): Observable<ApiResponse> {
    return this.http.patch<ApiResponse>(this.baseUrl.concat(url), data, this.baseRequestOptions()).pipe(tap(res => {
      this.validateRefreshToken(res.body);
    }));
  }

  putApi(url: string, data?: object): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(this.baseUrl.concat(url), data, this.baseRequestOptions()).pipe(tap(res => {
      this.validateRefreshToken(res.body);
    }));
  }

  deleteApi(url: string): Observable<ApiResponse> {
    return this.http.delete<ApiResponse>(this.baseUrl.concat(url), this.baseRequestOptions()).pipe(tap(res => {
      this.validateRefreshToken(res.body);
    }));
  }

  awsFilePut(postSignedurl: string, blob: object): Observable<any> {
    return this.http.request('PUT', postSignedurl, { body: blob });
  }
}


